import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "../reducers";
import sagas from "../sagas";
import createSagaMiddleware from "redux-saga";
import { createLogger } from 'redux-logger';
const sagaMiddleware = createSagaMiddleware();
const logger = createLogger({});
const store =   createStore(
    rootReducer,
    applyMiddleware(
      logger,
      sagaMiddleware,
    )
  );

export default store;

sagaMiddleware.run(sagas)